/**
 * 1-Click見積画面のレイアウト定数
 */
const LAYOUT = {
  /** ヘッダーの高さ(px) */
  HEADER_HEIGHT: 56,
} as const

export default LAYOUT
